
// SVG Icon: date-picker-icon
export default { id: "terriajs-date-picker-icon" };
export const id = "terriajs-date-picker-icon";
export const name = "date-picker-icon";
